<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <a-tabs default-active-key="1" >
            <a-tab-pane key="1" tab="企业审核任务" forceRender>
                <companyApproval ></companyApproval>
            </a-tab-pane>
            <a-tab-pane key="2" tab="商品审核任务" forceRender>
              <productApproval ></productApproval>
            </a-tab-pane>
        </a-tabs>
      </a-card>
    </a-col>
  </a-row>
</template>
<!-- create ji sheng hua-->
<script>
//ledgerAdd EnterpriseDetail

  import companyApproval from './companyApproval'
  import productApproval from './productApproval'
  import { campListMixins } from '../mixins/campListMixins'
  import JDate from '@/components/jeecg/JDate'


export default {
  name: '供应商管理',
  mixins: [campListMixins],
  components: {
    companyApproval,
    productApproval,
    JDate,
  },
  data() {
    return {

      // url: {
      //   list: '/sy/supplier/list',

      // },
    }
  },
  computed: {},
  created() {

  },
  methods: {

    changetime(createTime) {
      return createTime.replace('T', ' ')
    },


    modalFormOk(){
      console.log('1')
      this.loadData()
    },
    modalFormClose(){
      console.log('1')
      this.loadData()
    },
    modalLicenseOk(){
      console.log('1')
      this.loadData()
    },
    modalLicenseClose(){
      console.log('1')
      this.loadData()
    },
    modalDetailOk(){
      console.log('1')
      this.loadData()
    },
    modalDetailClose(){
      console.log('1')
      this.loadData()
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
/deep/.ant-table-row-cell-break-word:empty:after {
  content: '--';
}
</style>